const alphabet = 'abcdefghijklmnopqrstuvwxyz';

const getLetterByIndex = index => {
  const realIndex = index % alphabet.length;
  return alphabet.charAt(realIndex) || null;
};

export default getLetterByIndex;
